import cx from 'classnames'

import { Button } from '../../actions/button/Button'
import { ExtraTestInformation } from '../../structure/compareValues/ExtraTestInformation'
import { useUiContext } from '../../theme/uiContext'
import { Td, Th } from '../table/Table'
import type { Column } from './createColumnDefiner'

type Props<T> = {
  column: Column<T>
  row: T
  isHeader?: boolean
}

export const SortableTableDataCell = <T,>({
  column,
  row,
  isHeader,
}: Props<T>) => {
  const Cell = isHeader ? Th : Td

  const settingsContext = useUiContext()
  const isInDebugMode = settingsContext?.isInDebugMode
  const showExtraTestInformation = isInDebugMode && column.keyPath

  const display = column.getCellDisplay(row)

  return (
    <Cell
      className={cx(
        'group',
        {
          'whitespace-nowrap': column.noWrap,
          'text-right': column.alignment === 'right',
          'text-center': column.alignment === 'center',
          relative: showExtraTestInformation, // this fugs up sticky headers in the table a bit so we need to only apply it when needed
        },
        column.tdClassName?.(row),
      )}
    >
      {showExtraTestInformation && (
        <ExtraTestInformation
          currentVal={row}
          path={column.keyPath}
          formatter={() => display}
          prevVal={undefined}
          title={column.heading}
        />
      )}
      {column.onCellClick ? (
        <Button variant="text" onClick={(e) => column.onCellClick?.(row, e)}>
          {display}
        </Button>
      ) : (
        display
      )}
    </Cell>
  )
}
